import { FC, useCallback, useState } from 'react';
import { View } from 'react-native';
import { StackScreenProps } from '@react-navigation/stack';
import { Text } from '@/components/Text';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { useFocusEffect } from '@react-navigation/native';
import { useNotification } from '@/components/ui/therapist/Notification/NotificationProvider';
import { useSidebarAnimation } from '@/components/ui/therapist/CollapsibleSidebar/SidebarAnimationContext';

import PasswordGesture from '..';
import { hasInternetAsync } from '@/screens/HomeTherapist/helpers';
import { logError } from '@/utils/logHandling';
import { saveNewPatternLock } from '@/api/services/user';
import store from '@/stores/store';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import { styles } from './styles';

let SET_PASSWORD = '';

export const SetPassword: FC<
  StackScreenProps<TherapistStackParamList, 'SetPassword'>
> = ({ navigation }) => {
  const [state, setState] = useState<{
    message: string;
    status: string;
  }>({
    message: 'Legen Sie ein Sperrmuster fest.',
    status: 'normal',
  });
  const { setShowHeader } = useSidebarAnimation();
  const { showNotification } = useNotification();

  const onEnd = async (password: string) => {
    const hasInternet = await hasInternetAsync();

    if (hasInternet === false) {
      showNotification({
        type: 'error',
        title: 'Keine Verbindung',
        message:
          'Keine Verbindung zum neolexon Server. Überprüfen Sie Ihre Internetverbindung und versuchen es erneut.',
      });
      return;
    }

    if (SET_PASSWORD === '') {
      // The first password
      if (password.split(',').length < 4) {
        setState({
          status: 'wrong',
          message: 'Verbinden Sie mindestens 4 Punkte.',
        });
      } else {
        SET_PASSWORD = password;
        setState({
          status: 'normal',
          message: 'Wiederholen Sie das Sperrmuster.',
        });
      }
    } else {
      // The second password
      if (password === SET_PASSWORD) {
        try {
          const { hash, status } = await saveNewPatternLock(password);
          if (status === 200) {
            setState({
              status: 'right',
              message: 'Sperrmuster wird gesetzt...',
            });
            store.getActions().setAppLockPattern(hash);
            SET_PASSWORD = '';
            navigation.navigate('LockScreen');
            showNotification({
              type: 'success',
              title: 'Sperrmuster geändert.',
            });
          } else {
            navigation.navigate('LockScreen');
          }
        } catch (error) {
          logError('Could not save new lock pattern', error);
        }
      } else {
        setState({
          status: 'wrong',
          message: 'Sperrmuster Wiederholung stimmt nicht überein.',
        });
      }
    }
  };

  const onStart = () => {
    if (SET_PASSWORD === '') {
      setState({
        message: 'Sperrmuster festlegen',
        status: '',
      });
    } else {
      setState({
        message: 'Wiederholen Sie das Sperrmuster.',
        status: '',
      });
    }
  };

  const goBack = () => {
    setShowHeader(true);
    SET_PASSWORD = '';
    setState({
      message: 'Sperrmuster festlegen',
      status: 'normal',
    });
    navigation.goBack();
  };

  useFocusEffect(
    useCallback(() => {
      setShowHeader(false);

      return () => {
        setShowHeader(true);
      };
    }, []),
  );

  return (
    <View style={styles.setPasswordContainer}>
      <View style={{ maxHeight: 360, flex: 1 }}>
        <PasswordGesture
          status={state.status}
          message={state.message}
          onStart={() => onStart()}
          onEnd={onEnd}
          innerCircle={true}
          outerCircle={true}
          showNotification={showNotification}
        />
        <View style={styles.setPasswordBtnContainer}>
          <PressableNeolexon onPress={() => goBack()} style={styles.btn}>
            <Text style={styles.setPasswordText}>Abbrechen</Text>
          </PressableNeolexon>
        </View>
      </View>
    </View>
  );
};
